const API_BASE_URL = (process.env.VUE_APP_API_BASE_URL || "http://127.0.0.1:8000/api").replace(
  /\/$/,
  ""
);

function parseApiError(error, fallbackMessage = "Operacia zlyhala.") {
  const status = error?.response?.status || error?.status || 500;
  const payload = error?.response?.data || error?.payload || {};

  return {
    status,
    message: payload?.message || fallbackMessage,
    errors: payload?.errors || null,
  };
}

function toArray(value) {
  return Array.isArray(value) ? value : [];
}

function mapBrandFilter(item) {
  if (typeof item === "string") {
    return {
      name: item,
      product_count: null,
    };
  }

  return {
    name: item?.name || item?.brand || "",
    product_count:
      typeof item?.product_count === "undefined" || item?.product_count === null
        ? null
        : Number(item.product_count),
  };
}

export function mapSolidwayProduct(item = {}) {
  const category = item.category_ref || item.categoryRef || null;

  return {
    id: item.id,
    solidwayId: item.solidway_id,
    internalCode: item.internal_code || "",
    ean: item.ean || "",
    slug: item.slug || "",
    title: item.title || "",
    alternativeTitle: item.alternative_title || "",
    packagePrice: item.package_price,
    packageSalePrice: item.package_sale_price,
    unitPrice: item.unit_price,
    unitSalePrice: item.unit_sale_price,
    saleUnit: item.sale_unit || "",
    minSaleUnitsAmount: item.min_sale_units_amount,
    availability: item.availability || "",
    stockStatus: item.stock_status || "",
    stockAmount: item.stock_amount,
    imageLink: item.image_link || "",
    additionalImageLinks: toArray(item.additional_image_links),
    productType: item.product_type || "",
    categoryPath: item.category || "",
    category,
    brand: item.brand || "",
    pattern: item.pattern || "",
    grossWeight: item.gross_weight,
    productDetail: toArray(item.product_detail),
    accessories: toArray(item.accessories),
    variantOfId: item.variant_of_id,
    variantOf: item.variant_of || "",
    videos: toArray(item.videos),
    certificates: toArray(item.certificates),
    documents: toArray(item.documents),
    shortDescription: item.short_description || "",
    description: item.description || "",
  };
}

function buildQuery(params = {}) {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === null || typeof value === "undefined" || value === "") return;
    query.set(key, String(value));
  });
  const text = query.toString();
  return text ? `?${text}` : "";
}

export async function fetchSolidwayProducts(params = {}) {
  const response = await fetch(`${API_BASE_URL}/solidway-products${buildQuery(params)}`, {
    headers: {
      Accept: "application/json",
    },
  }).catch((error) => {
    throw parseApiError(error, "Nepodarilo sa nacitat ponuku produktov.");
  });

  const payload = await response.json().catch(() => ({}));

  if (!response.ok) {
    const error = new Error(payload?.message || "Nepodarilo sa nacitat ponuku produktov.");
    error.status = response.status;
    error.payload = payload;
    throw parseApiError(error, "Nepodarilo sa nacitat ponuku produktov.");
  }

  const paginator = payload?.products || {};
  const products = toArray(paginator.data).map(mapSolidwayProduct);

  return {
    products,
    pagination: {
      currentPage: Number(paginator.current_page || 1),
      lastPage: Number(paginator.last_page || 1),
      perPage: Number(paginator.per_page || params.per_page || 24),
      total: Number(paginator.total || products.length),
    },
    filters: {
      categories: toArray(payload?.filters?.categories),
      brands: toArray(payload?.filters?.brands).map(mapBrandFilter).filter((brand) => brand.name),
      availability: toArray(payload?.filters?.availability),
    },
  };
}

export async function fetchSolidwayProduct(slugOrId, options = {}) {
  const query = buildQuery({
    track_view: options.trackView === false ? "0" : undefined,
  });
  const response = await fetch(`${API_BASE_URL}/solidway-products/${encodeURIComponent(slugOrId)}${query}`, {
    headers: {
      Accept: "application/json",
    },
  }).catch((error) => {
    throw parseApiError(error, "Nepodarilo sa nacitat detail produktu.");
  });

  const payload = await response.json().catch(() => ({}));

  if (!response.ok) {
    const error = new Error(payload?.message || "Produkt nebol najdeny.");
    error.status = response.status;
    error.payload = payload;
    throw parseApiError(error, "Produkt nebol najdeny.");
  }

  return mapSolidwayProduct(payload?.product || {});
}

export async function sendSolidwayProductInquiry(slugOrId, form) {
  const response = await fetch(
    `${API_BASE_URL}/solidway-products/${encodeURIComponent(slugOrId)}/inquiry`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(form),
    }
  ).catch((error) => {
    throw parseApiError(error, "Dopyt sa nepodarilo odoslat.");
  });

  const payload = await response.json().catch(() => ({}));

  if (!response.ok) {
    const error = new Error(payload?.message || "Dopyt sa nepodarilo odoslat.");
    error.status = response.status;
    error.payload = payload;
    throw parseApiError(error, "Dopyt sa nepodarilo odoslat.");
  }

  return payload;
}
